import React, {ReactElement} from "react";
import {Box, Typography, useTheme} from "@mui/material";
import {StyledBoxColumn, StyledSpan} from "@/shared/StyledComponents";
import {ArrowForwardOutlined} from "@mui/icons-material";
import {BORDER_RADIUS_MEDIUM, CARD_SHADOW_DARK, PD_XLG, SZ_JUMBO} from "@/shared/dimens";

export function ChooseCard(props: {
  icon: ReactElement,
  title: string,
  description: string,
  highlighted?: boolean,
  onClick: () => void,
}): ReactElement {
  const theme = useTheme();
  const highlighted = props.highlighted ?? false;
  return <StyledBoxColumn
    onClick={props.onClick}
    style={{
      boxSizing: "content-box",
      flexBasis: 0,
      flexGrow: 1,
      height: SZ_JUMBO,
      borderRadius: BORDER_RADIUS_MEDIUM,
      background: highlighted ? theme.palette.primary.main : theme.palette.grey[100],
      color: highlighted ? theme.palette.primary.contrastText : undefined,
      padding: PD_XLG,
      cursor: "pointer",
      display: "flex",
      transition: "0.2s",
    }}
    sx={{
      "&:hover": {
        boxShadow: CARD_SHADOW_DARK,
      },
    }}>
    <Box sx={{
      width: 48,
      height: 48,
      borderRadius: "50%",
      backgroundColor: highlighted ? "rgba(255,255,255,0.2)" : theme.palette.primary.main,
      color: highlighted ? theme.palette.primary.contrastText : theme.palette.primary.contrastText,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      {props.icon}
    </Box>
    <Typography variant={"h5"}>
      {props.title}
    </Typography>
    <Typography>
      {props.description}
    </Typography>
    <StyledSpan/>
    <ArrowForwardOutlined style={{alignSelf: "flex-end"}}/>
  </StyledBoxColumn>;
}
